import { render, staticRenderFns } from "./was-developing.vue?vue&type=template&id=95320d86&scoped=true&"
import script from "./was-developing.vue?vue&type=script&lang=js&"
export * from "./was-developing.vue?vue&type=script&lang=js&"
import style0 from "./was-developing.vue?vue&type=style&index=0&id=95320d86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95320d86",
  null
  
)

export default component.exports